/**
 * @generated SignedSource<<dc88f11dd5c513ef769be0c82927b7dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicCollectionSeoCollection$data = {
  readonly description: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"hooksUseDynamicMetaTags">;
  readonly " $fragmentType": "topicCollectionSeoCollection";
};
export type topicCollectionSeoCollection$key = {
  readonly " $data"?: topicCollectionSeoCollection$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicCollectionSeoCollection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicCollectionSeoCollection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksUseDynamicMetaTags"
    }
  ],
  "type": "Collection",
  "abstractKey": null
};

(node as any).hash = "e5fe40f7c9fa1edcf681b79c9196a1d0";

export default node;
